import { render } from "./ModalJSONIntegracao.vue?vue&type=template&id=30f06b72&ts=true"
import script from "./ModalJSONIntegracao.vue?vue&type=script&lang=ts"
export * from "./ModalJSONIntegracao.vue?vue&type=script&lang=ts"

import "./ModalJSONIntegracao.vue?vue&type=style&index=0&id=30f06b72&lang=css"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__